import { Analytics, getAnalytics, isSupported } from 'firebase/analytics'
import { FirebaseApp, getApps, initializeApp } from 'firebase/app'

import { getConfig } from '@/configs'

// Firebase 앱과 Analytics 인스턴스
let app: FirebaseApp | null = null
let analytics: Analytics | null = null

export const initializeFirebase = async (): Promise<void> => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const config = await getConfig()
    const firebaseConfig = config.firebase

    if (!firebaseConfig) {
      throw new Error('Firebase 설정이 없습니다.')
    }

    if (!app) {
      const existingApps = getApps()
      app = existingApps.length === 0 ? initializeApp(firebaseConfig) : existingApps[0]
    }

    const isSupportedAnalytics = await isSupported()

    if (!analytics && isSupportedAnalytics) {
      analytics = getAnalytics(app)
    }

    if (!analytics) {
      console.warn('Firebase Analytics는 현재 환경에서 지원되지 않습니다.')
    }
  } catch (error) {
    console.error('Analytics 초기화 실패:', error)
  }
}

export const getFirebaseApp = () => app

export const getFirebaseAnalytics = () => analytics
